import React from 'react';
import { Tag } from 'antd';
import type { ProductCategory } from '../productCategoriesApi';

interface CategoryTagPickerProps {
  categories: ProductCategory[];
  value?: string | null;
  onChange?: (value: string) => void;
  disabled?: boolean;
  ariaLabel: string;
}

/**
 * Category choice as the category's own coloured tags (ProductCategoryTag.color,
 * presets in components/products/ProductCategoriesTab.tsx). Acts as a radio
 * group so it works as an antd Form.Item control and with the keyboard.
 */
const CategoryTagPicker: React.FC<CategoryTagPickerProps> = ({
  categories, value, onChange, disabled, ariaLabel,
}) => (
  <div className="product-card-category-pick" role="radiogroup" aria-label={ariaLabel}>
    {categories.map((category) => {
      const selected = category.id === value;
      return (
        <button
          key={category.id}
          type="button"
          role="radio"
          aria-checked={selected}
          disabled={disabled}
          className={selected ? 'product-card-category-choice is-selected' : 'product-card-category-choice'}
          onClick={() => onChange?.(category.id)}
        >
          <Tag color={category.color || 'default'} bordered>{category.name}</Tag>
        </button>
      );
    })}
  </div>
);

export default CategoryTagPicker;
